import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { TalhaoRow } from '../../../../@types';
import RowExpansionColumn from '../components/row-expansion-column';

const NUMBER_FORMAT_OPTIONS = {
  maximumFractionDigits: 2,
  useGrouping: true,
};

const RowExpansionTemplate = (
  data: TalhaoRow,
  showPMS?: boolean,
  sementeDeCobertura?: boolean,
) => (
  <div className="formgrid grid col-11 ml-6 p-0">
    {sementeDeCobertura && (
      <RowExpansionColumn
        label="Dose (kg/ha):"
        value={formatNumber(data.dose || 0, NUMBER_FORMAT_OPTIONS)}
      />
    )}
    {!sementeDeCobertura && (
      <RowExpansionColumn
        label="Densidade (pl/ha):"
        value={formatNumber(data.densidade || 0, NUMBER_FORMAT_OPTIONS)}
      />
    )}
    {showPMS && !sementeDeCobertura && (
      <RowExpansionColumn
        label="PMS (gr):"
        value={formatNumber(data.pms || 0, NUMBER_FORMAT_OPTIONS)}
      />
    )}
    {!sementeDeCobertura && (
      <RowExpansionColumn
        label="PG (%):"
        value={formatNumber(data.pg || 0, NUMBER_FORMAT_OPTIONS)}
      />
    )}
    <RowExpansionColumn
      label="Ciclo (dias):"
      value={formatNumber(data.ciclo || 0, NUMBER_FORMAT_OPTIONS)}
    />
    {!sementeDeCobertura && (
      <RowExpansionColumn
        label="Unidade:"
        value={data.unidade?.descricao || ''}
      />
    )}
  </div>
);

export default RowExpansionTemplate;
